import { Card, GKButton, GKTypography, Grid2, Typography } from "components";
import { useFetchQuery } from "hooks/useQueries";
import DashboardLayout from "layouts/DashboardLayout";
import { useState } from "react";
import { moneyCommaSeparator } from "utils/MathFunction";
import { GET_WALLET_TOP_UP_LIST } from "utils/apiRoutes";
import RateCardModal from "./RateCardModal";
import WalletFullHistory from "./WalletFullHistory";
import WalletHistory from "./WalletHistory";
import WalletTopupModal from "./WalletTopupModal";

const Wallet = () => {
  const [openTopUp, setOpenTopUp] = useState(false);
  const [openRateCardModal, setOpenRateCardModal] = useState(false);

  const { data, isFetching } = useFetchQuery({
    key: ["GET_WALLET_BALANCE"],
    route: GET_WALLET_TOP_UP_LIST,
  });

  return (
    <DashboardLayout title="Wallet">
      <Grid2 container spacing={1}>
        <Grid2 size={12}>
          <Card>
            <Grid2 container spacing={1}>
              <Grid2 size={6}>
                <Typography
                  fontWeight={400}
                  fontSize={12}
                  display={"flex"}
                  alignItems={"center"}
                  color={"var(--neutral-500)"}
                >
                  My Balance
                </Typography>
                <GKTypography
                  fontWeight={600}
                  fontSize={24}
                  color={"var(--black)"}
                  loading={isFetching}
                >
                  {`₹ ${moneyCommaSeparator(+data?.data?.data?.amount)}`}
                </GKTypography>
              </Grid2>
              <Grid2
                size={6}
                display={"flex"}
                justifyContent={"flex-end"}
                alignItems={"center"}
                gap={1}
              >
                <GKButton
                  variant="outlined"
                  color="secondary"
                  onClick={() => setOpenRateCardModal(true)}
                  sx={{ background: "var(--white)" }}
                >
                  Add-ons
                </GKButton>
                <GKButton
                  variant="outlined"
                  color="primary"
                  onClick={() => setOpenTopUp(true)}
                >
                  Add Balance
                </GKButton>
              </Grid2>
            </Grid2>
          </Card>
        </Grid2>
        <Grid2 size={4}>
          <WalletFullHistory />
        </Grid2>
        <Grid2 size={8}>
          <WalletHistory />
        </Grid2>
      </Grid2>

      {openTopUp && (
        <WalletTopupModal open={openTopUp} setOpen={setOpenTopUp} data={data} />
      )}

      {openRateCardModal && (
        <RateCardModal
          open={openRateCardModal}
          setOpen={setOpenRateCardModal}
        />
      )}
    </DashboardLayout>
  );
};

export default Wallet;
